import React from "react";
import C3Chart from "react-c3js";
import moment from "moment";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import {
  defaultStartDate,
  categoryAxis,
  unwrapList,
  emptyLineChart,
} from "./chartUtils";

export default class ChatWithAgentChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      chartData: emptyLineChart("Total Chats", "#0A49B6"),
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  async fetchData(startDate, endDate) {
    try {
      const res = await clientService.chatWithAgent(startDate, endDate);
      console.log("Chat With Agent response:", res);
      const data = unwrapList(res);
      data.forEach((d) => {
        d.dateObj = moment(d._id);
      });
      console.log("Chat With Agent data:", data);
      const xAxis = data.map((a) => a._id);
      const counts = data.map((a) => a.count);
      console.log("Chat With Agent chart:", { xAxis, counts });

      this.setState({
        chartData: xAxis.length
          ? {
              bindto: "#chat-with-agent",
              x: "x",
              columns: [["x", ...xAxis], ["Total Chats", ...counts]],
              colors: { "Total Chats": "#0A49B6" },
            }
          : emptyLineChart("Total Chats", "#0A49B6"),
      });
    } catch (error) {
      console.error(error);
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
        />
        <AnalyticsChartCard title="Chat With Agent">
          <C3Chart
            data={this.state.chartData}
            size={{ height: 340 }}
            transition={{ duration: 1000 }}
            axis={categoryAxis}
            padding={{ bottom: 0, top: 0 }}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
